import React from 'react'
import { storiesOf } from '@storybook/react'
import { Loading } from './Loading';

storiesOf('Common/Loading', module)
  .add('Bar', () => (
    <Loading show='true'/>
  ))
  .add('Spinner', () => (
    <Loading show='true' type="spinner"/>
  ))


/** WEBPACK FOOTER **
 ** ./src/components/common/Loading/Loading.stories.jsx
 **/